import './language-line.scss';

import flowRight from 'lodash/flowRight';
import { bool, func, number } from 'prop-types';
import React, { Component } from 'react';
import { Label } from 'reactstrap';

import ExtendableInput, {
  withCharacterLimit,
  withClipboardCopy,
} from '../../generic/Input';
import RemoveButton from '../../generic/RemoveButton';
import { campaignLineShape } from '../../prop-types';
import { languagesOptions } from '../constants';
import { findTypeLimits, hasNoFields, isEditable } from '../utils';

const LanguageLineInput = flowRight(
  withCharacterLimit,
  withClipboardCopy,
)(ExtendableInput);

class LanguageLine extends Component {
  constructor(props) {
    super(props);
    this.toggleHoverState = this.toggleHoverState.bind(this);
    this.state = {
      isHovering: false,
    };
  }

  toggleHoverState(state) {
    this.setState({ isHovering: state });
  }

  render() {
    const {
      languageIndex,
      line,
      onChange,
      onRemove,
      removable,
      index,
      showActions,
      readOnly,
    } = this.props;

    if (hasNoFields(line)) {
      return null;
    }
    const { isHovering } = this.state;
    const limits = findTypeLimits(line.product);

    const inputProps = {
      onChange,
      readOnly: readOnly || !(onChange && isEditable(line)),
    };
    const { product } = line;
    const languageCode = line[`language${languageIndex}`].toUpperCase();
    const { label: languageLabel } = languagesOptions.find(
      item => item.value === languageCode,
    );

    const { id } = line;
    const pathPrefix = id || index;

    return (
      <tr
        onMouseEnter={() => this.toggleHoverState(true)}
        onMouseLeave={() => this.toggleHoverState(false)}
      >
        {showActions && (
          <td className="c-language-line__action">
            {isHovering && (
              <RemoveButton
                id={`${pathPrefix}.remove${languageIndex}`}
                className="c-language-line__remove-button border-0"
                disabled={!removable}
                onClick={() => onRemove(languageCode)}
              />
            )}
          </td>
        )}
        <td className="c-language-line__country va-middle">{languageLabel}</td>

        {product.hasSubTitle && (
          <td>
            <Label htmlFor={`${pathPrefix}.subTitle${languageIndex}`} hidden>
              Headline
            </Label>
            <LanguageLineInput
              name={`${pathPrefix}.subTitle${languageIndex}`}
              id={`${pathPrefix}.subTitle${languageIndex}`}
              type="text"
              bsSize="sm"
              value={line[`subTitle${languageIndex}`] || ''}
              length={limits.subTitle}
              {...inputProps}
            />
          </td>
        )}

        {product.hasTitle && (
          <td>
            <Label htmlFor={`${pathPrefix}.title${languageIndex}`} hidden>
              Subline
            </Label>
            <LanguageLineInput
              name={`${pathPrefix}.title${languageIndex}`}
              id={`${pathPrefix}.title${languageIndex}`}
              type="text"
              bsSize="sm"
              value={line[`title${languageIndex}`] || ''}
              length={limits.title}
              {...inputProps}
            />
          </td>
        )}

        {product.hasText && (
          <td>
            <Label htmlFor={`${pathPrefix}.desc${languageIndex}`} hidden>
              Description
            </Label>
            <LanguageLineInput
              name={`${pathPrefix}.desc${languageIndex}`}
              id={`${pathPrefix}.desc${languageIndex}`}
              type="text"
              bsSize="sm"
              value={line[`desc${languageIndex}`] || ''}
              length={limits.desc}
              {...inputProps}
            />
          </td>
        )}

        {product.hasCta && (
          <td>
            <Label htmlFor={`${pathPrefix}.cta${languageIndex}`} hidden>
              CTA
            </Label>
            <LanguageLineInput
              name={`${pathPrefix}.cta${languageIndex}`}
              id={`${pathPrefix}.cta${languageIndex}`}
              type="text"
              bsSize="sm"
              value={line[`cta${languageIndex}`] || ''}
              length={limits.cta}
              {...inputProps}
            />
          </td>
        )}

        {product.hasLp && (
          <td>
            <Label htmlFor={`${pathPrefix}.landingPage${languageIndex}`} hidden>
              LP
            </Label>
            <LanguageLineInput
              name={`${pathPrefix}.landingPage${languageIndex}`}
              id={`${pathPrefix}.landingPage${languageIndex}`}
              type="text"
              bsSize="sm"
              value={line[`landingPage${languageIndex}`] || ''}
              length={limits.landingPage}
              {...inputProps}
            />
          </td>
        )}
      </tr>
    );
  }
}

LanguageLine.propTypes = {
  line: campaignLineShape.isRequired,
  languageIndex: number.isRequired,
  onChange: func,
  onRemove: func,
  removable: bool,
  index: number,
  showActions: bool,
  readOnly: bool,
};

LanguageLine.defaultProps = {
  onChange: undefined,
  onRemove: undefined,
  removable: false,
  index: null,
  showActions: true,
  readOnly: false,
};

export default LanguageLine;
